<script setup lang="ts">
/** Pill select with a custom chevron; options come through the default slot. */
const props = defineProps<{
  label?: string
  id?: string
  required?: boolean
  disabled?: boolean
  error?: string
  hint?: string
  name?: string
}>()

const model = defineModel<string | number | null>()

// useId() matches between the server render and the browser; a random id did not (hydration mismatch).
const fallbackId = `sofax-select-${useId()}`
const inputId = computed(() => props.id || fallbackId)
</script>

<template>
  <div>
    <label v-if="label" :for="inputId" class="field-label">
      {{ label }}<span v-if="required" class="text-accent"> *</span>
    </label>
    <select
      :id="inputId"
      v-model="model"
      :name="name"
      :required="required"
      :disabled="disabled"
      :aria-invalid="error ? 'true' : undefined"
      class="field-select"
      :class="{ 'field-error': !!error }"
    >
      <slot />
    </select>
    <span v-if="error" class="field-hint !text-red-600 dark:!text-red-400">{{ error }}</span>
    <span v-else-if="hint" class="field-hint">{{ hint }}</span>
  </div>
</template>
